import "./mailcal.css";

export type FoldCountProps = {
  count: number;
  /** Says what pressing it opens ("38 older messages"). */
  accessibilityLabel: string;
  onPress: () => void;
  testID: string;
};

/** Messages folded away in a long conversation (Gmail): a round count on a hairline; pressing it opens them. */
export function FoldCount({ count, accessibilityLabel, onPress, testID }: FoldCountProps) {
  return (
    <div className="b-fold-count">
      <button type="button" className="b-fold-count-round" aria-label={accessibilityLabel} onClick={onPress} data-testid={testID}>
        {count}
      </button>
      <span className="b-fold-count-line" />
    </div>
  );
}
